// @ verdors
import moment from 'moment'

// @utilities
import { getIbansAccounts } from 'utilities/expensesByCategories/accountsUtilities';
import { getNumberCard } from 'utilities/expensesByCategories/cardsUtilities';
import getFiltersRelatedToContractType from './getFiltersRelatedToContractType';
import getBanksFromAggregatorData from 'utilities/aggregator/getBanksFromAggregatorData';
import getAccountsFromAggregatorData from 'utilities/aggregator/getAccountsFromAggregatorData';
import getCardsFromAggregatorData from 'utilities/aggregator/getCardsFromAggregatorData';
import getBanksCode from 'utilities/aggregator/getBanksCode';

// @ constants
import { DATE_FORMAT_API } from 'constants/index';
import { CATEGORY, BANK, ALL_BANKS, DATE, CUSTOM_ACCOUNTS, ALL_ACCOUNTS, LAST_YEAR_COMPARISON } from 'constants/expensesByCategories/filters';
const { ACCOUNTS } = require('constants/aggregator/products')

const getSelectedCategory = immFilters => {
    let selectedCategory = immFilters.getIn([CATEGORY,'selected'])
    return selectedCategory ? [selectedCategory] : []
}

const getFormatedDate = (date, format) => moment(date).format(format)

const getFormatedCompareDate = (date, format) => moment(date).subtract(1, 'year').format(format)

const getFromDateByDefault = format => moment().subtract(1, 'year').format(format)

const getFromDateByCompareDefault = format => moment().subtract(2, 'year').format(format)

const getToDateByDefault = format => moment().format(format)

const getToDateByCompareDefault = format => moment().subtract(1, 'year').format(format)

const getToDate = (immFilters, compareLastYear = false) => {
    let toDate = immFilters.getIn([DATE, 'to'])
    if(!compareLastYear) {
        return toDate ? getFormatedDate(toDate, DATE_FORMAT_API) : getToDateByDefault(DATE_FORMAT_API)
    } else {
        return toDate ? getFormatedCompareDate(toDate, DATE_FORMAT_API) : getToDateByCompareDefault(DATE_FORMAT_API)
    }
}

const getFromDate = (immFilters, compareLastYear = false) => {
    let fromDate = immFilters.getIn([DATE, 'from'])
    if(!compareLastYear) {
        return fromDate ? getFormatedDate(fromDate, DATE_FORMAT_API) : getFromDateByDefault(DATE_FORMAT_API)
    } else {
        return fromDate ? getFormatedCompareDate(fromDate, DATE_FORMAT_API) : getFromDateByCompareDefault(DATE_FORMAT_API)
    }
}

const getOpenBankAccounts = (immAccounts, hasCustomAccounts = true) => {
    const accountType = hasCustomAccounts ? CUSTOM_ACCOUNTS : ALL_ACCOUNTS;
    return getIbansAccounts(immAccounts, accountType);
}

const getAllAggregatedBanksContracts = immAggregatorData => {
    const accountList = getAccountsFromAggregatorData(immAggregatorData)
    const cardList = getCardsFromAggregatorData(immAggregatorData)

    return accountList.concat(cardList);   
}

const getIbansFromAggregatedAccounts = (accountList = []) => accountList.map(account => account.iban)

const getNumberCardFromAggregatedCards = (cardList = []) => cardList.map(card => card.number)

const getNumberCardsAndIbansFromContracts = (contractList = []) => {
    return contractList.map(contract =>
        contract.product === ACCOUNTS ? 
            contract.iban :
            contract.number
    )
}

const getFilteredAggregatedBanksContracts = (immAggregatorData, immFilters) => {
    const contractList = getAllAggregatedBanksContracts(immAggregatorData)
    const foundContractList = findProductsByUserBankId(contractList, immAggregatorData, immFilters)

    return foundContractList;
}

const getFilteredAggregatedBanksAccounts = (immAggregatorData, immFilters) => {
    const accountList = getAccountsFromAggregatorData(immAggregatorData)
    const foundAccountList = findProductsByUserBankId(accountList, immAggregatorData, immFilters)
    const ibanList = getIbansFromAggregatedAccounts(foundAccountList)

    return ibanList;
}

const getFilteredAggregatedBanksCards = (immAggregatorData, immFilters) => {
    const cardList = getCardsFromAggregatorData(immAggregatorData)
    const foundCardList = findProductsByUserBankId(cardList, immAggregatorData, immFilters)
    const numberCardList = getNumberCardFromAggregatedCards(foundCardList)

    return numberCardList;
}

const findProductsByUserBankId = (productList, immAggregatorData, immFilters) => {
    const bankCode = immFilters.getIn([BANK, 'selected']);
    const userBankId = getUserBankIdFromBankCode(immAggregatorData, bankCode);

    if(bankCode === ALL_BANKS) return productList

    const filteredProductList = productList.filter(contract => contract.bank === userBankId);

    return filteredProductList;
}

const getUserBankIdFromBankCode = (immAggregatorData, bankCode) => {
    const bankList = getBanksFromAggregatorData(immAggregatorData)
    const foundBank = bankList.find(bank => bank.code === bankCode)

    return foundBank ? foundBank.userBankId : null;
}

const getOpenBankCards = (immCards, accountType = CUSTOM_ACCOUNTS) => getNumberCard(immCards, immCards, accountType)

const getLastYearComparison = immFilters => {
    return immFilters.getIn([LAST_YEAR_COMPARISON, 'active']) ? immFilters.getIn([LAST_YEAR_COMPARISON, 'active']) : false
}

const getSelectedBanks = (immAggregatorData, immFilters) => {
    const selectedBankCode = immFilters.getIn([BANK,'selected'])

    return selectedBankCode === ALL_BANKS ? getBanksCode(immAggregatorData) : [selectedBankCode]
}

const getDefaultContracts = (isPfmAggregatorView, immAggregatorData, immAccounts, immCards) => {
    if (isPfmAggregatorView) {
        const contractList = getAllAggregatedBanksContracts(immAggregatorData)

        return getNumberCardsAndIbansFromContracts(contractList)
    } else {
        return getIbansAccounts(immAccounts).concat(getNumberCard(immCards, immCards))
    }
}

const getDefaultCards = (isPfmAggregatorView, immAggregatorData, immCards) => {
    const cardList = getCardsFromAggregatorData(immAggregatorData)
    return isPfmAggregatorView ? getNumberCardFromAggregatedCards(cardList) : getOpenBankCards(immCards)
}

const getDefaultAccounts = (isPfmAggregatorView, immAggregatorData, immAccounts) => {
    const accountList = getAccountsFromAggregatorData(immAggregatorData);
    return isPfmAggregatorView ? getIbansFromAggregatedAccounts(accountList) : getOpenBankAccounts(immAccounts)
}

const getFilteredContracts = (immFilters, immAccounts, hasCustomAccounts, immCards, accountType, immAggregatorData, isPfmAggregatorView, isCreditFilterSelected, isDebitFilterSelected) => {
    if (isPfmAggregatorView) {

        if(isDebitFilterSelected && isCreditFilterSelected) {
            const filteredContractList = getFilteredAggregatedBanksContracts(immAggregatorData, immFilters);
            return getNumberCardsAndIbansFromContracts(filteredContractList)
        }
        
        if(isDebitFilterSelected && !isCreditFilterSelected) {
            const filteredAccountList = getAccountsFromAggregatorData(immAggregatorData)
            return getIbansFromAggregatedAccounts(filteredAccountList)
        }
        
        if(!isDebitFilterSelected && isCreditFilterSelected){
            const filteredCardList = getCardsFromAggregatorData(immAggregatorData)
            return getNumberCardFromAggregatedCards(filteredCardList)
        }
    } else {
        const openBankContractList = getOpenBankAccounts(immAccounts, hasCustomAccounts).concat(getOpenBankCards(immCards, accountType))
        return openBankContractList;
    }
}

const getFilteredAccounts = (immFilters, immAccounts, hasCustomAccounts, immAggregatorData, isPfmAggregatorView, isDebitFilterSelected) => {
    if (isPfmAggregatorView) {
        return isDebitFilterSelected ? getFilteredAggregatedBanksAccounts(immAggregatorData, immFilters) : []
    } else {
        return getOpenBankAccounts(immAccounts, hasCustomAccounts)
    }
}

const getFilteredCards = (immFilters, immCards, accountType, immAggregatorData, isPfmAggregatorView, isCreditFilterSelected) => {
    if (isPfmAggregatorView) {
        return isCreditFilterSelected ? getFilteredAggregatedBanksCards(immAggregatorData, immFilters) : []
    } else {
        return getOpenBankCards(immCards, accountType)
    }
}

const getDefaultFiltersObject = (immAccounts, immCards, immAggregatorData, isPfmAggregatorView) => {
    return {
        categorySelected: [],
        fromDate: getFromDateByDefault(DATE_FORMAT_API),
        toDate: getToDateByDefault(DATE_FORMAT_API),
        fromCompareDate: getFromDateByCompareDefault(DATE_FORMAT_API),
        toCompareDate: getToDateByCompareDefault(DATE_FORMAT_API),
        contracts: getDefaultContracts(isPfmAggregatorView, immAggregatorData, immAccounts, immCards),
        accounts: getDefaultAccounts(isPfmAggregatorView, immAggregatorData, immAccounts),
        cards: getDefaultCards(isPfmAggregatorView, immAggregatorData, immCards),
        lastYearComparison: false,
        ...getFiltersRelatedToContractType(),
        banks: isPfmAggregatorView ? getBanksCode(immAggregatorData) : null,
    }
}

const getFiltersObject = (immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView) => {
    const hasCustomAccounts = immFilters.getIn([CUSTOM_ACCOUNTS, 'active']),
        accountType = hasCustomAccounts ? CUSTOM_ACCOUNTS : ALL_ACCOUNTS;

    const { isCreditFilterSelected, isDebitFilterSelected } = getFiltersRelatedToContractType(immFilters)

    return {
        categorySelected: getSelectedCategory(immFilters),
        fromDate: getFromDate(immFilters),
        toDate: getToDate(immFilters),
        fromCompareDate: getFromDate(immFilters, true),
        toCompareDate: getToDate(immFilters, true),
        contracts: getFilteredContracts(immFilters, immAccounts, hasCustomAccounts, immCards, accountType, immAggregatorData, isPfmAggregatorView, isCreditFilterSelected, isDebitFilterSelected),
        accounts: getFilteredAccounts(immFilters, immAccounts, hasCustomAccounts, immAggregatorData, isPfmAggregatorView, isDebitFilterSelected),
        cards: getFilteredCards(immFilters, immCards, accountType, immAggregatorData, isPfmAggregatorView, isCreditFilterSelected),
        lastYearComparison: getLastYearComparison(immFilters),
        isCreditFilterSelected,
        isDebitFilterSelected,
        banks: isPfmAggregatorView ? getSelectedBanks(immAggregatorData, immFilters) : null
    }
}

const getFiltersObjectToRequestData = (immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView) => {
    return immFilters ?
        getFiltersObject(immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView) :
        getDefaultFiltersObject(immAccounts, immCards, immAggregatorData, isPfmAggregatorView);
}

export default getFiltersObjectToRequestData
